const BASE_URL = import.meta.env.VITE_API_BASE || 'https://ampdig-digital-apim-ae-prd.azure-api.net/ppc-be-v3/api';
const apiEndPoints = {
  CAMPAIGN_LIST: BASE_URL + '/campaign',
  CAMPAIGN_ADD: BASE_URL + '/campaign',
  CAMPAIGN_DETAILS: BASE_URL + '/campaign/campaignId',

  PROMOTION_LIST: BASE_URL + '/promotion',
  PROMOTION_ADD: BASE_URL + '/promotion',
  PROMOTION_DETAILS: BASE_URL + '/promotion/promotionId',

  OFFER_LIST: BASE_URL + '/offers',
  OFFER_ADD: BASE_URL + '/offers',
  OFFER_DETAILS: BASE_URL + '/offers/offerId',
  OFFER_ACTIVATE: BASE_URL + '/offers/offerId/activate',

  OFFER_RULES: BASE_URL + '/offers/offerId/rule',
  OFFER_RULE_ADD: BASE_URL + '/offerrule',
  OFFER_RULE_DELETE: BASE_URL + '/offerrule/ruleId',

  OFFER_RULE_PRODUCTS: BASE_URL + '/offerrule/ruleId/products',
  OFFER_RULE_PRODUCT_ADD: BASE_URL + '/offerrule/ruleId/products',
  OFFER_RULE_PRODUCT_DELETE: BASE_URL + '/offerrule/ruleId/products',

  OFFER_CAF_FILE_UPLOAD: BASE_URL + '/Offers/uploadcaffile',
  OFFER_CAF_FILE: BASE_URL + '/Offers/caffile/fileId',
  OFFER_CAF_FILE_LIST: BASE_URL + '/Offers/fileId/caffiles',

  SUPPLIER_LIST: BASE_URL + '/Supplier',
  SUPPLIER_ITEM: BASE_URL + '/Supplier',
  PURCHASE_REBATE_SUPPLIER_LIST: BASE_URL + '/PurchaseRebateSupplier/Supplier',
  PURCHASE_REBATE_SUPPLIER_ITEM: BASE_URL + '/PurchaseRebateSupplier/Supplier',
  PURCHASE_REBATE_SUPPLIER_ADD: BASE_URL + '/PurchaseRebateSupplier/Supplier',
  PURCHASE_REBATE_SUPPLIER_DELETE:
    BASE_URL + '/PurchaseRebateSupplier/Supplier',

  PURCHASE_REBATE_LIST: BASE_URL + '/PurchaseRebates',
  PURCHASE_REBATE_ITEM: BASE_URL + '/PurchaseRebates/id',
  PURCHASE_REBATE_CAF_LIST: BASE_URL + '/Offers/PurchaseRebate/CafFiles',
  PURCHASE_REBATE_PRODUCT_LIST: BASE_URL + '/PurchaseRebateProduct',
  PURCHASE_REBATE_PRODUCT_ITEM: BASE_URL + '/PurchaseRebateProduct',

  FUNDER_ITEM_LIST: BASE_URL + '/DealFunder',
  FUNDER: BASE_URL + '/DealFunder/{dealFunderId}',
  FUNDER_ITEM_LIST_WITH_REGIONS:
    BASE_URL + '/DealFunder?onlyWithCustomRegions=true',

  SITE_REGION_ADD: BASE_URL + '/SiteRegions',
  SITE_REGION_UPDATE: BASE_URL + '/SiteRegions/siteRegionId',
  SITE_REGION_ITEM_LIST:
    BASE_URL + '/dealfunder/funderId/site-regions?expand=true',
  ALL_SITE_REGION_ITEM_LIST: BASE_URL + '/siteregions?expand=true',
  REGION_ITEM_LIST: BASE_URL + '/dealfunder/funderId/regions',
  ALL_REGION_ITEM_LIST: BASE_URL + '/regions',

  BATCH_PROCESS_RUN: BASE_URL + '/batchprocess',
  BATCH_PROCESS: BASE_URL + '/batchprocess',
  BATCH_PROCESS_ROLLBACK: BASE_URL + '/batchprocess/id',

  POINT_CONVERSION_RATE_LIST: BASE_URL + '/ConversionRate/points',
  POINT_CONVERSION_RATE_ADD: BASE_URL + '/ConversionRate/points',
  DOLLAR_CONVERSION_RATE_LIST: BASE_URL + '/ConversionRate/dollars',
  DOLLAR_CONVERSION_RATE_ADD: BASE_URL + '/ConversionRate/dollars',
  DOLLAR_CONVERSION_RATE_DELETE: BASE_URL + '/ConversionRate/dollars/rateId',
  DOLLAR_CONVERSION_RATE_SET_END_DATE:
    BASE_URL + '/ConversionRate/dollars/rateId',

  EFT_CATEGORY_LIST: BASE_URL + '/EftCategory',

  LOSS_PREVENTION_SETTINGS: BASE_URL + '/LossPrevention/Settings',
};
export default apiEndPoints;
